import React, { useEffect, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import { URLS, createMarkup, CRYPTO_SECRET_KEY, replaceNbsp } from "src/_config";
import { useCmsApi } from "src/_common/hooks/actions/cms/cmsApiHook";
import { toast } from "react-toastify";
import parse from "html-react-parser";

const Cryptr = require("cryptr");
const cryptr = new Cryptr(CRYPTO_SECRET_KEY);

export default function CmsPage() {
  const { eventId, cmsId } = useParams<any>();
  const { slug } = useParams<any>();
  const cmsApi = useCmsApi();
  const [content, setContent] = useState<any>();
  const history = useHistory();

  const getGameCmsContentDetails = () => {
    var params = {
      game_id: cryptr.decrypt(eventId),
      id: cryptr.decrypt(cmsId),
    };

    cmsApi.callGameCms(
      params,
      (message: string, resp: any) => {
        if (resp && resp.list) {
          // console.log(resp.list)
          setContent(resp.list);
        }
      },
      (message: string) => {
        // toast.error(message)
      }
    );
  };

  const getCmsContentDetails = () => {
    cmsApi.callGetCmsContent(
      { slug },
      (message: string, resp: any) => {
        if (resp && resp.list) {
          setContent(resp.list);
        }
      },
      (message: string) => {
        // toast.error(message)
      }
    );
  };

  const gotoRodeoEventsPage = () => {
    console.log({ history });
    if (cmsId) {
      history.push(`/event/${eventId}`);
    } else {
      if (history.length > 1) {
        history.goBack();
      } else {
        history.push(URLS.HOME);
      }
    }
  };

  useEffect(() => {
    if (cmsId) {
      getGameCmsContentDetails();
    }
  }, [cmsId]);

  useEffect(() => {
    if (slug) {
      // console.log(slug)
      getCmsContentDetails();
    }
  }, [slug]);

  return (
    <React.Fragment>
      <div className="main-width">
        <h2 className="page-title text-left">
          <a className="back-history" onClick={gotoRodeoEventsPage}>
            <img src="/images/black-left.svg" alt="back" />
          </a>
          {/* <span>About </span>Us */}
          {content?.title || <span>Back</span>}
          <hr className="color-white" />
        </h2>
        <hr className="color-white" />
        <div className="form-box-new">
          <div className="row">
            {content && content.long_description ? (
              parse(replaceNbsp(content.long_description))
            ) : (
              <p className="normal-text">No content added!</p>
            )}
          </div>
        </div>
      </div>
      {/* <div className='footer-panel'>
                <p>© Copyright 2023 Inside Rodeo</p>
            </div> */}
    </React.Fragment>
  );
}
